import React, { useEffect } from "react";
import InspectionHistoryBody from "../components/ads/inspection-history";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";

export default function InspectionHistory() {
  const { user } = React.useContext(AuthContext);
  const history = useHistory();
  // useEffect(() => {
  //   document.title = "Bidding History | FameWheels";
  //   if (!user) {
  //     history.push("/")
  //   }
  // }, []);
  return (
    <>
      <InspectionHistoryBody />
    </>
  );
}
